export const cn = (...classNames: (string | false | undefined)[]): string =>
    classNames.filter((it) => typeof it === "string").join(" ");
